import React from 'react'
import ButtonGroup from '@/components/ui/ButtonGroup'
import Button from '@/components/ui/Buttons/Button'
import { Puff } from '@/components/ui/Loaders'
import { ButtonTrigger } from '@/components/ui/Menu/Trigger'
import ToggleButton from '@/components/ui/Buttons/ToggleButton'
import Menu from '@/components/ui/Menu'
import { Dropdown } from '@mui/base/Dropdown'
import { usePreferredRuntime } from '@/app/routes/Dashboard/CreateRouteButton/CreateRouteButton.hooks'
import { getRouteRuntimeLabel } from '@/app/routes/Dashboard/Dashboard.hooks'
import { Runtime, RuntimeOptions } from '@/config/app'

export type CreateRouteButtonProps = {
  onCreate: (runtime: Runtime) => void
  isLoading?: boolean
  title?: string
}

const CreateRouteButton = ({ onCreate, isLoading = false, title = 'route' }: CreateRouteButtonProps) => {
  const [preferredRuntime] = usePreferredRuntime()
  const runtime = getRouteRuntimeLabel(preferredRuntime)

  return (
    <ButtonGroup>
      <Button onClick={() => onCreate(preferredRuntime)} disabled={isLoading} StartIcon={isLoading && <Puff />}>
        Create {runtime} {title}
      </Button>
      <Dropdown>
        <ButtonTrigger component={ToggleButton}>Test</ButtonTrigger>
        <Menu placement={'bottom-end'}>
          <Menu.Body>
            {RuntimeOptions.map((option) => (
              <Menu.Item key={option.value} isArrowVisible={false} onClick={() => onCreate(option.value)}>
                {option.label}
              </Menu.Item>
            ))}
          </Menu.Body>
        </Menu>
      </Dropdown>
    </ButtonGroup>
  )
}

export default CreateRouteButton
